export enum INTEGRATIONS_APP_DIRECTORY_SORT_TYPES {
  AZ = 'AZ',
  POPULAR = 'POPULAR',
}

export const INTEGRATIONS_APP_DIRECTORY_SORT_TYPES_LABELS: { [k in INTEGRATIONS_APP_DIRECTORY_SORT_TYPES]: string } = {
  AZ: 'A-Z',
  POPULAR: 'Most Popular',
}
